import { c as _c } from "react/compiler-runtime";
import React, { useContext, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import CategoryStoresContext from 'data-hooks/context/CategoryStoresContext';
import useProductCardContext from 'data-hooks/useProductCardContext';
import ProductCardOnDisplayInShowroomMultiple from './ProductCardOnDisplayInShowroomMultiple';
import ProductCardOnDisplayInShowroomSingle from './ProductCardOnDisplayInShowroomSingle';
const ProductCardOnDisplayInShowroom = () => {
  const $ = _c(2);
  const location = useLocation();
  const {
    productStoresMap
  } = useContext(CategoryStoresContext);
  const productCardContext = useProductCardContext();
  location?.search;
  let t0;
  bb0: {
    if (!location?.search) {
      t0 = false;
      break bb0;
    }
    const searchParams = new URLSearchParams(location.search);
    t0 = searchParams.get("showMultipleStores") === "true";
  }
  const enableMultipleStores = t0;
  const hasNewStoresData = enableMultipleStores && productStoresMap && Object.keys(productStoresMap).length > 0;
  const hasOldSlugData = productCardContext?.onDisplayInShowroomSlug;
  if (hasNewStoresData) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <ProductCardOnDisplayInShowroomMultiple />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (hasOldSlugData) {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <ProductCardOnDisplayInShowroomSingle />;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  return null;
};
export default ProductCardOnDisplayInShowroom;